import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "./client";

export const useGetWithdrawRequests = () => {
    const token = localStorage.getItem("accessToken");
    return useQuery({
        queryKey: ["withdrawlResuest"],
        queryFn: async () => {
            const response = await client("withdraw-requests", {
                method: "GET",
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};

export const useWithdrawRequestsStatus = () => {
    const token = localStorage.getItem("accessToken");
    return useMutation({
        mutationFn: async ({ id, status }) => {
            const response = await client(`withdraw-requests/${id}/status`, {
                method: "PUT",
                data: { status },
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};
